module.exports = __webpack_public_path__ + "img/blessing_prize_2.5c8372df.png";